"use client"

import {
  FaCopy,
  FaTrash,
  FaEdit,
  FaExternalLinkAlt,
  FaChartBar,
  FaCheck,
  FaLock,
} from "react-icons/fa"

export default function ActionButtons({
  shortUrl,
  user,
  copied,
  onCopy,
  onDelete,
  onAnalytics,
  onEdit,
}) {
  const plan = user?.plan || "free"
  const canEdit = ["standard", "premium", "dedicated"].includes(plan)

  const BRAND = {
    primary: "#3B82F6",
    primaryDark: "#2563EB",
    primarySoft: "#EFF6FF",
    border: "#DBEAFE",
    muted: "#9CA3AF",
  }

  return (
    <div className="btn-group btn-group-sm">
      {/* Copy */}
      <button className="btn btn-outline-secondary" onClick={onCopy}>
        {copied ? <FaCheck /> : <FaCopy />}
      </button>

      {/* Open link (primary action) */}
      <a
        href={shortUrl}
        target="_blank"
        rel="noreferrer"
        className="btn"
        title="Open link"
        style={{
          background: BRAND.primary,
          borderColor: BRAND.primary,
          color: "#FFFFFF",
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.background = BRAND.primaryDark)
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.background = BRAND.primary)
        }
      >
        <FaExternalLinkAlt />
      </a>

      {/* Analytics */}
      <button
        className="btn"
        title={
          plan === "free"
            ? "Basic analytics (upgrade for more)"
            : "View analytics"
        }
        onClick={onAnalytics}
        style={{
          background: "#FFFFFF",
          color: BRAND.primary,
          border: `1px solid ${BRAND.border}`,
        }}
      >
        <FaChartBar />
      </button>

      {/* Edit / Locked */}
      <button
        className="btn"
        title={
          canEdit ? "Edit link" : "Upgrade to Premium to edit links"
        }
        onClick={canEdit ? onEdit : undefined}
        disabled={!canEdit}
        style={{
          background: "#FFFFFF",
          color: canEdit ? BRAND.primary : BRAND.muted,
          border: `1px solid ${BRAND.border}`,
          cursor: canEdit ? "pointer" : "not-allowed",
        }}
      >
        {canEdit ? <FaEdit /> : <FaLock />}
      </button>

      {/* Delete */}
      <button className="btn btn-outline-danger" onClick={onDelete}>
        <FaTrash />
      </button>
    </div>
  )
}